/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { SpeakerFeature } from "./types";

export default function Speaker(feature: SpeakerFeature) {
  let playAction = feature.actions.play;
  let pauseAction = feature.actions.pause;
  let setVolumeAction = feature.actions.set_volume;
  let playFavoriteAction = feature.actions.play_favorite;
  let seekPreviousAction = feature.actions.seek_previous;
  let seekNextAction = feature.actions.seek_next;
  /* eslint-disable no-unused-vars */
  let playUrlAction = feature.actions.play_url;
  /* eslint-enable no-unused-vars */

  this.play = () => {
    if (feature.is_playing) {
      return $.Deferred.resolve();
    } else {
      return this.executeDeviceAction(playAction, {}, { message: "Playing" });
    }
  };

  this.playFavorite = (title) => {
    return this.executeDeviceAction(
      playFavoriteAction,
      { title },
      { message: `Playing favorite "${title}"` }
    );
  };

  this.pause = () => {
    if (feature.is_playing) {
      return this.executeDeviceAction(pauseAction, {}, { message: "Pausing" });
    } else {
      return $.Deferred.resolve();
    }
  };

  this.setVolume = (speakerVolume) => {
    return this.executeDeviceAction(
      setVolumeAction,
      { volume: speakerVolume },
      { message: `Setting volume to ${speakerVolume}%` }
    );
  };

  this.canSeekNext = () => seekNextAction != null;

  this.seekNext = () => {
    return this.executeDeviceAction(
      seekNextAction,
      {},
      { message: "Seeking next track" }
    );
  };

  this.canSeekPrevious = () => seekPreviousAction != null;

  this.seekPrevious = () => {
    return this.executeDeviceAction(
      seekPreviousAction,
      {},
      { message: "Seeking previous track" }
    );
  };

  // let Sonos app/speaker configuration decide name
  this.isNameEditable = () => false;

  return {
    status: feature.status,
    is_playing: feature.is_playing,
    volume: feature.volume,
    favorites: feature.favorites,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/speaker.js